import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDSbLzASO5ucCO-M0pYY0WWi1qEe1JLy3Q",
  authDomain: "block-forever.firebaseapp.com",
  projectId: "block-forever",
  storageBucket: "block-forever.firebasestorage.app",
  messagingSenderId: "239203130575",
  appId: "1:239203130575:web:3716c0ded121b047ff6bba",
  measurementId: "G-GEDM321L09",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

export const functions = getFunctions(app);

// Use a callable function
// export const createPaymentIntent = httpsCallable(
//   functions,
//   "createPaymentIntent"
// );
export const createCheckoutSession = httpsCallable(
  functions,
  "createCheckoutSession"
);
export const verifyPayment = httpsCallable(functions, "verifyPayment");

// export const createPaymentIntent = functions.httpsCallable(`newRequest`);
